import React from 'react';
import { fraction } from 'shared/constants/math';
import { FormattedNumber } from 'react-intl';
import { metricSupportsChange } from 'shared/utils/metricChange';

const MetricChange = ({ metric, row, aligned = true }) => {
  if (!metricSupportsChange(metric)) {
    return null;
  }
  let percentageChange = null;
  let className = 'metric-change';

  if (row.dateComparisonResults?.length === 1) {
    const comparison = row.dateComparisonResults?.[0];
    const comparisonValue = comparison[metric.name];
    if (comparisonValue) {
      if (comparisonValue && !row[metric.name]) {
        percentageChange = -1;
      } else {
        percentageChange = fraction(
          row[metric.name] - comparisonValue,
          comparisonValue,
        );
      }
    }
    if ((metric.negative && percentageChange < 0) || (!metric.negative && percentageChange > 0)) {
      className += ' positive';
    } else if ((metric.negative && percentageChange > 0) || (!metric.negative && percentageChange < 0)) {
      className += ' negative';
    }
  }

  if (aligned) {
    className += ' aligned';
  }

  return (
    <div
      className={className}
    >
      <span className="noto">
        {percentageChange > 0 ? '🡑' : ''}
        {percentageChange < 0 ? '🡓' : ''}
      </span>
      {percentageChange != null && (
        <FormattedNumber
          value={Math.abs(percentageChange)}
          style="percent"
          maximumFractionDigits={0}
        />
      )}
    </div>
  );
};

export default MetricChange;
